import { Button, Stack, Typography } from "@compass/core";
import { SubmitButton } from "components";
import "moment-timezone";
import { ScreenType } from "./AprPage";
import { AprRequestFilter } from "generated/openApi";

export const AprPageHeader = (props: {
  handle: string;
  screen: ScreenType;
  filter: AprRequestFilter;
  setScreen: (screen: ScreenType) => void;
  generateReport: () => void;
}) => {
  return (
    <Stack direction="row" justifyContent={"space-between"}>
      <Typography variant="inherit">{props.filter?.aprSchoolYearId != 6 ? props.handle : "ED Reports"}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.screen === "report" && (
          <Button variant="outlined" onClick={(e) => props.setScreen("config")}>
            Back
          </Button>
        )}

        {props.screen === "config" && <SubmitButton onClick={props.generateReport} label={"Generate"} />}
      </Stack>
    </Stack>
  );
};
